async function readEntries(
  item: FileSystemDirectoryEntry,
): Promise<FileSystemEntry[]> {
  let isEmpty = false;
  const result: FileSystemEntry[] = [];
  const directoryReader = item.createReader();
  while (!isEmpty) {
    const currentItems = await new Promise<FileSystemEntry[]>(
      (resolve, reject) => {
        directoryReader.readEntries(resolve, reject);
      },
    );
    result.push(...currentItems);
    isEmpty = currentItems.length === 0;
  }
  return result;
}

// lib.dom types isDirectory as a plain boolean rather than a discriminant.
function isDirectoryEntry(
  item: FileSystemEntry,
): item is FileSystemDirectoryEntry {
  return item.isDirectory;
}

function isHidden(item: FileSystemEntry): boolean {
  return item.name.startsWith('.');
}

async function fileSystemEntryRead(
  item: FileSystemEntry | null,
): Promise<FileSystemEntry[]> {
  if (!item || isHidden(item)) {
    return [];
  }
  if (item.isFile) {
    return [item];
  }

  const allEntries: FileSystemEntry[] = [];
  const result: FileSystemEntry[] = [];
  if (isDirectoryEntry(item)) {
    const entries = await readEntries(item);
    allEntries.push(...entries);
  }
  while (allEntries.length > 0) {
    const entry = allEntries.shift();
    if (!entry) {
      break;
    }
    if (isHidden(entry)) {
      continue;
    }
    if (entry.isFile) {
      result.push(entry);
      continue;
    }
    if (isDirectoryEntry(entry)) {
      const entries = await readEntries(entry);
      allEntries.push(...entries);
    }
  }
  return result;
}

export default fileSystemEntryRead;
